import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class EmbassyService {

  constructor() { }

  readableFileSize(size) {
    let units = ['B', 'KB', 'MB'];
    let i = 0;
    if (size != null) {
      while (size >= 1024) {
        size /= 1024;
        ++i;
      }
      return size?.toFixed(2) + ' ' + units[i];
    }
  }
}
